import axios, { AxiosResponse } from 'axios';
// TODO: Fix this, shouldn't import from component.
import { OrderDetail } from '../../components/receipt/transactions/TransactionDetailV2/TransactionDetailReceipt/OrderDetailType';
import { GET_INVOICES, GET_ORDERS, getOrderDetailUrl } from './constants';

function reject(error) {
  if (!error.response) {
    return Promise.reject(error);
  }

  const { data } = error.response;

  if (Array.isArray(data.errors) && data.errors.length > 0) {
    const errorDetail = data.errors[0];
    return Promise.reject(
      new Error(errorDetail.user_message || errorDetail.message)
    );
  }

  if (data.errors) {
    return Promise.reject(new Error(data.errors));
  }

  if (data.message) {
    return Promise.reject(new Error(data.message));
  }

  return Promise.reject(error);
}

export function getOrders(query: any, headers: any) {
  return axios
    .get(GET_ORDERS, {
      params: query,
      headers,
    })
    .catch(reject);
}

export function getOrderDetail(id): Promise<AxiosResponse<OrderDetail>> {
  return axios.get(getOrderDetailUrl(id)).catch(reject);
}

export function getInvoices(query: any, headers: any) {
  return axios.get(GET_INVOICES, { params: query, headers }).catch(reject);
}
